var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReparingHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002833"
    },
    d: "M473.68,396.8V102.4c0-7.04-5.76-12.8-12.8-12.8H51.36c-7.04,0-12.8,5.76-12.8,12.8v294.4 C38.56,396.8,474.72,396.8,473.68,396.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 106.64,
    style: {
      fill: "#002833"
    },
    width: 396.72,
    height: 290.16
  })), /*#__PURE__*/React.createElement("rect", {
    y: 396.8,
    style: {
      fill: "#E8E8E8"
    },
    width: 512,
    height: 8.56
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#40596B"
    },
    points: "486.4,422.4 25.6,422.4 0,405.36 512,405.36 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5F5F"
    },
    cx: 255.84,
    cy: 243.2,
    r: 30.48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#048FEA"
    },
    d: "M355.92,258.24v-30l-30.56-3.04c-1.76-6.4-4.4-12.48-7.84-18l19.68-24.08l-21.2-21.2l-25.04,20.48 c-5.2-2.72-10.88-4.88-16.8-6.24l-3.28-32.96h-15.04h-0.16H240.8l-3.28,32.96c-5.92,1.36-11.52,3.44-16.8,6.24l-25.04-20.48 l-21.2,21.2l19.68,24.08c-3.44,5.52-6.08,11.6-7.84,18l-30.56,3.04v30l30.56,3.04c1.76,6.4,4.4,12.48,7.84,18l-19.68,24.08 l21.2,21.2l25.04-20.48c5.2,2.72,10.88,4.88,16.8,6.24l3.28,32.96h15.04H256h15.04l3.28-32.96c5.92-1.36,11.52-3.44,16.8-6.24 l25.04,20.48l21.2-21.2l-19.68-24.08c3.44-5.52,6.08-11.6,7.84-18L355.92,258.24z M255.84,288.32c-24.96,0-45.12-20.24-45.12-45.12 c0-24.96,20.24-45.12,45.12-45.12c24.96,0,45.12,20.24,45.12,45.12C300.96,268.16,280.8,288.32,255.84,288.32z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReparingHover);
export default __webpack_public_path__ + "static/media/ReparingHover.a90a7166b7f0e32a6f12111e10884f4b.svg";
export { ForwardRef as ReactComponent };